// Highway corridor data — T049 scaffold + T055 operator records (Aug 2026)
// Each record renders a dedicated /areas/<corridor-slug> page with real exits, staging, tolls, danger zones.

export const corridors = {

  "الطريق الدائري": {
    id: "الطريق الدائري",
    slug: "الطريق الدائري",
    name: "ونش انقاذ الطريق الدائري",
    metaDescription: "ونش انقاذ الطريق الدائري: تغطية جميع المخرجات (المعادي، مدينة نصر، القاهرة الجديدة، الجيزة). خدمة 24 ساعة بخصم 50% - 01044844492.",
    intro: "الطريق الدائري أطول محور مروري في القاهرة الكبرى (120 كم تقريباً) وأكثرها كثافة حوادث. أوناشنا موزعة على نقاط التقاطع الرئيسية لاستجابة سريعة أينما كنت على الدائري.",
    responseTime: "10–20 دقيقة على الطريق الدائري",
    exits: ["مخرج المعادي", "مخرج مدينة نصر", "مخرج القاهرة الجديدة / الشروق", "مخرج الجيزة / الهرم", "مخرج 6 أكتوبر", "مخرج طريق إسكندرية الصحراوي", "مخرج المرج / الإسماعيلية"],
    staging: ["نقاط التجمع عند مخرج المعادي ومدخل حلوان", "تجمعات مخرج مدينة نصر - جسر السويس", "تجمعات مخرج القاهرة الجديدة", "تجمعات مخرج الجيزة"],
    tolls: ["لا توجد رسوم طرق على الدائري نفسه؛ رسوم مذكورة في الفاتورة إن لزم المرور بكباري مأجورة بديلة."],
    dangerZones: ["الزحام عند المخرجين الشرقي والغربي وقت الذروة", "الأكتاف الضيقة في بعض القطاعات بين الكباري", "مناطق الحوادث المتكررة عند مخرج المعادي ومخرج الجيزة"],
    relatedAreas: ["المعادي", "مدينة نصر", "مصر الجديدة", "التجمع الخامس", "الجيزة", "حلوان", "6 أكتوبر"],
    commonIssues: ["الزحام الشديد وقت الذروة", "الأكتاف الضيقة", "الحاجة للسلامة المرورية الكاملة عند الرفع"],
    equipment: ["ونش سحب عادي (Wheel-lift)", "ونش سطحة هيدروليكية كامل (Flatbed)", "معدات إشارات المرور والتحذير"],
    process: ["استقبال البلاغ وتحديد المخرج الدقيق", "توجيه أقرب ونش على المحور", "تأمين موقع الحادث بأقماع تحذير", "السحب الآمن وإزالة المركبة من المسار"],
    safety: ["إشارات المرور الكاملة قبل الرفع", "المسافة الآمنة من المركبات المارة", "الرفع السريع لمنع التكدس"],
  }
,
  "طريق السويس": {
    id: "طريق السويس",
    slug: "طريق السويس",
    name: "ونش انقاذ طريق السويس",
    metaDescription: "ونش انقاذ طريق السويس: مداخل القاهرة الجديدة، الشروق، العبور، بدر. خدمة 24 ساعة بخصم 50% - 01044844492.",
    intro: "طريق السويس من أهم الطرق السريعة شرق القاهرة. أوناشنا موزعة على مداخل القاهرة الجديدة والشروق والعبور وبدر لتغطية سريعة لكل النقاط.",
    responseTime: "15–20 دقيقة على طريق السويس",
    exits: ["مدخل القاهرة الجديدة", "مدخل الشروق", "مدخل العبور", "مدخل بدر", "مدخل العاشر من رمضان", "مدخل الإسماعيلية", "مدخل السويس"],
    staging: ["نقطة تجمع مدخل القاهرة الجديدة (الشيراتون)", "نقطة تجمع مدخل العبور", "نقطة تجمع مدخل بدر"],
    tolls: ["رسوم الطرق تُضاف على الفاتورة عند التحرك لمسافات طويلة."],
    dangerZones: ["مناطق التحويلات عند مدخل القاهرة الجديدة", "الازدحام صباحًا في اتجاه السويس", "السرعة العالية على الطريق المفتوح"],
    relatedAreas: ["مصر الجديدة", "الشروق", "العبور", "بدر", "مدينة المستقبل", "العاشر من رمضان", "التجمع الخامس"],
    commonIssues: ["السرعة العالية", "القيود على التوقف على الكتف", "الطويل بين المحطات الخدمية"],
    equipment: ["ونش سحب عادي (Wheel-lift)", "ونش سطحة للسيارات الفارهة (Flatbed)"],
    process: ["تأكيد البلاغ", "توجيه أقرب ونش", "السحب الآمن"],
    safety: ["تشغيل الإشارات التحذيرية", "تنبيه المركبات المارة", "سرعة الرفع"],
  }
,
  "طريق مصر–الإسكندرية الصحراوي": {
    id: "طريق مصر–الإسكندرية الصحراوي",
    slug: "طريق مصر–الإسكندرية الصحراوي",
    name: "ونش انقاذ طريق مصر–الإسكندرية الصحراوي",
    metaDescription: "ونش انقاذ طريق مصر–الإسكندرية الصحراوي: Smart Village، 6 أكتوبر، الكيلو 21. خدمة 24 ساعة بخصم 50% - 01044844492.",
    intro: "طريق مصر–إسكندرية الصحراوي شريان رئيسي بين القاهرة والإسكندرية، بأطوال تتجاوز 220 كم. خدماتنا تشمل الإنقاذ السريع على الكيلو 0 حتى الكيلو 60+، مع توفر نقل كامل بين المدينتين.",
    responseTime: "20–35 دقيقة على طريق مصر–إسكندرية الصحراوي (يتوقف على المسافة من القاهرة)",
    exits: ["Smart Village", "6 اكتوبر", "الشيخ زايد", "الواحات", "العياط", "الصف", "أطفيح", "الكريمات", "وادي النطرون", "برج العرب الجديدة"],
    staging: ["نقطة تجمع Smart Village", "نقطة تجمع 6 أكتوبر", "نقطة تجمع الكيلو 21"],
    tolls: ["رسوم الطرق تُضاف على الفاتورة حسب المسافة. النقل بين القاهرة والإسكندرية يبدأ من 2,600 ج.م."],
    dangerZones: ["السرعة العالية جداً على الكيلو 30-80", "نقص الخدمات على بعض الكيلومترات", "الرمال المتحركة أحياناً"],
    relatedAreas: ["6 أكتوبر", "الشيخ زايد", "الإسكندرية", "الساحل الشمالي", "طريق الواحات", "حدائق الأهرام"],
    commonIssues: ["السرعة العالية", "نقص المحطات الخدمية", "الظلام على بعض القطاعات"],
    equipment: ["ونش سحب عادي", "ونش سطحة كامل (Flatbed)", "ونش ثقيل للمعدات"],
    process: ["تأكيد البلاغ والمخرج", "توجيه أقرب ونش متاح", "السحب الآمن"],
    safety: ["الإشارات التحذيرية الكاملة", "تنبيه المركبات المارة", "الإخلاء السريع للموقع"],
  }
,
  "محور 26 يوليو": {
    id: "محور 26 يوليو",
    slug: "محور 26 يوليو",
    name: "ونش انقاذ محور 26 يوليو",
    metaDescription: "ونش انقاذ محور 26 يوليو: 6 أكتوبر، الشيخ زايد، Smart Village. خدمة 24 ساعة بخصم 50% - 01044844492.",
    intro: "محور 26 يوليو من المحاور الحديثة عالية الكثافة، يربط القاهرة بـ 6 أكتوبر والشيخ زايد. خدماتنا موزعة على مداخل ومخارج المحور.",
    responseTime: "20–30 دقيقة على محور 26 يوليو",
    exits: ["مدخل 6 أكتوبر", "مدخل الشيخ زايد", "مدخل Smart Village", "مخرج الجيزة"],
    staging: ["نقطة تجمع مدخل 6 أكتوبر", "نقطة تجمع مدخل الشيخ زايد", "نقطة تجمع مدخل Smart Village"],
    tolls: ["رسوم الطرق تُضاف على الفاتورة."],
    dangerZones: ["السرعة العالية في القطاع الشمالي", "الدمج في حركة المرور وقت الذروة", "الأكتاف الضيقة في بعض القطاعات"],
    relatedAreas: ["6 أكتوبر", "الشيخ زايد", "الجيزة", "المهندسين", "الدقي"],
    commonIssues: ["السرعة العالية", "الدمج", "الازدحام في أوقات الذروة"],
    equipment: ["ونش سحب عادي", "ونش سطحة كامل (Flatbed)"],
    process: ["تأكيد البلاغ", "توجيه أقرب ونش", "السحب الآمن"],
    safety: ["الإشارات التحذيرية", "تنبيه المركبات المارة", "الرفع السريع"],
  }
,
  "طريق العين السخنه": {
    id: "طريق العين السخنه",
    slug: "طريق العين السخنه",
    name: "ونش انقاذ طريق العين السخنة",
    metaDescription: "ونش انقاذ طريق العين السخنة: القطامية، بورتو السخنة، العين السخنة. خدمة 24 ساعة بخصم 50% - 01044844492.",
    intro: "طريق العين السخنة من أطول الطرق الصحراوية وأكثرها استخدامًا في الصيف. خدماتنا تغطي من القطامية حتى بورتو السخنة والعين السخنة.",
    responseTime: "20–30 دقيقة على طريق العين السخنة",
    exits: ["مدخل القطامية", "مدخل بيفرلي هيلز", "مدخل بورتو السخنة", "مدخل العين السخنة", "مدخل السخنة القديمة"],
    staging: ["نقطة تجمع مدخل القطامية", "نقطة تجمع مدخل العين السخنة"],
    tolls: ["رسوم الطريق تُضاف على الفاتورة. النقل إلى العين السخنة من القاهرة يبدأ من 2,600 ج.م."],
    dangerZones: ["السرعة العالية جداً", "المسافات الطويلة بين المحطات الخدمية", "الرمال المتحركة في بعض القطاعات"],
    relatedAreas: ["المعادي", "التجمع الخامس", "القطامية", "العين السخنة", "بورتو السخنة"],
    commonIssues: ["السرعة العالية", "المسافات الطويلة", "قلة الخدمات في الصيف"],
    equipment: ["ونش سحب عادي", "ونش سطحة كامل (Flatbed)"],
    process: ["تأكيد البلاغ", "توجيه أقرب ونش", "السحب الآمن"],
    safety: ["الإشارات التحذيرية", "تنبيه المركبات المارة", "الرفع السريع"],
  }
,
  "طريق الإسماعيلية": {
    id: "طريق الإسماعيلية",
    slug: "طريق الإسماعيلية",
    name: "ونش انقاذ طريق الإسماعيلية",
    metaDescription: "ونش انقاذ طريق الإسماعيلية: العبور، الشروق، العاشر، الإسماعيلية. خدمة 24 ساعة بخصم 50% - 01044844492.",
    intro: "طريق الإسماعيلية من أقدم الطرق السريعة في مصر، يربط القاهرة بالإسماعيلية. خدماتنا موزعة على مداخل العبور والشروق والعاشر.",
    responseTime: "15–25 دقيقة على طريق الإسماعيلية",
    exits: ["مدخل العبور", "مدخل الشروق", "مدخل العاشر من رمضان", "مدخل الإسماعيلية", "مدخل المستقبل"],
    staging: ["نقطة تجمع مدخل العبور", "نقطة تجمع مدخل الشروق", "نقطة تجمع مدخل العاشر"],
    tolls: ["رسوم الطرق تُضاف على الفاتورة."],
    dangerZones: ["مناطق التحويلات", "محطات البنزين القليلة", "السرعة العالية على المسار المفتوح"],
    relatedAreas: ["مصر الجديدة", "العبور", "الشروق", "بدر", "العاشر من رمضان", "مدينة المستقبل"],
    commonIssues: ["السرعة العالية", "القيود على التوقف", "المناطق النائية"],
    equipment: ["ونش سحب عادي", "ونش سطحة كامل (Flatbed)"],
    process: ["تأكيد البلاغ", "توجيه أقرب ونش", "السحب الآمن"],
    safety: ["الإشارات التحذيرية", "تنبيه المركبات المارة", "الرفع السريع"],
  }
,
  "طريق الواحات (يشمل محور 6 أكتوبر)": {
    id: "طريق الواحات (يشمل محور 6 أكتوبر)",
    slug: "طريق الواحات",
    name: "ونش انقاذ طريق الواحات ومحور 6 أكتوبر",
    metaDescription: "ونش انقاذ طريق الواحات: 6 أكتوبر، دهشور، الواحات، صحراء الغربي. خدمة 24 ساعة بخصم 50% - 01044844492.",
    intro: "طريق الواحات ومحور 6 أكتوبر يربطان غرب القاهرة بالصحراء الغربية. خدماتنا تغطي الكمبوندات والمجمعات السكنية على طول الطريق.",
    responseTime: "20–35 دقيقة على طريق الواحات",
    exits: ["مدخل 6 أكتوبر", "مدخل الشيخ زايد", "وصلة دهشور", "مدخل طريق الفيوم", "مدخل الواحات"],
    staging: ["نقطة تجمع مدخل 6 أكتوبر", "نقطة تجمع مدخل الواحات"],
    tolls: ["رسوم الطرق تُضاف على الفاتورة حسب المسافة."],
    dangerZones: ["السرعة العالية في القطاع الصحراوي", "الظلام في بعض القطاعات", "ندرة الخدمات على المسار البعيد"],
    relatedAreas: ["6 أكتوبر", "الشيخ زايد", "حدائق أكتوبر", "حدائق الأهرام", "طريق الواحات"],
    commonIssues: ["السرعة العالية", "ندرة الخدمات", "الظلام"],
    equipment: ["ونش سحب عادي", "ونش سطحة كامل (Flatbed)"],
    process: ["تأكيد البلاغ", "توجيه أقرب ونش", "السحب الآمن"],
    safety: ["الإشارات التحذيرية", "تنبيه المركبات المارة", "الرفع السريع"],
  }
};

export function getCorridor(id) {
  return corridors[id] || null;
}

